import { useDispatch, useSelector } from '@redux';
import { confirmForcePayment } from '@redux/orders/actions';
import { Modal, Form, Input } from 'antd';
import FormItem from 'components/form/FormItem';
import { RestInputContext } from 'components/form/RestInputContext';
import { useTranslation } from 'react-i18next';

interface IConfirmPaidModalProps {
  id?: string;
  visible?: boolean;
  onCancel?: () => void;
}

const ConfirmPaidModal = ({
  id,
  visible,
  onCancel,
}: IConfirmPaidModalProps) => {
  const { t } = useTranslation();
  const loading = useSelector((state) => state.orders.loading);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    dispatch(
      confirmForcePayment({
        data: {
          id: id,
          data: values,
        },
        options: {
          isShowSuccessNoti: true,
        },
      }),
    ).then((res) => {
      if (!res?.payload?.error) {
        onCancel();
        window.location.reload();
      }
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading,
      }}
      title={t('Confirm paid')}
    >
      <RestInputContext.Provider value={{ form }}>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <FormItem name="confirmPaidNote" label={t('orders.cancelNote')}>
            <Input.TextArea />
          </FormItem>
        </Form>
      </RestInputContext.Provider>
    </Modal>
  );
};

export default ConfirmPaidModal;
